export var TransitionState;
(function (TransitionState) {
    TransitionState["Exit"] = "exit";
    TransitionState["Container"] = "container";
    TransitionState["Enter"] = "enter";
    TransitionState["ContainerRect"] = "container-rect";
})(TransitionState || (TransitionState = {}));
